<template>
  <div>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix"><b><i class="el-icon-s-unfold"></i>合同签订</b></div>
      <div class=' contijiao wkbmf loaded' v-if="quoform.cvencheck=='已确认'">
        <div class='stamp stamp1'> </div>
      </div>
      <div class="text item text-center tableheight1" style="width:100%;height:60px;">
        <div class="pull-right" style="margin-bottom: 15px">
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" plain size="medium" @click.native="PriceSubmit"
              :disabled="quoform.cvencheck=='已确认'">确认</el-button>
          </Debounce>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="warning" plain @click.native="down()" size="medium">合同模板下载</el-button>
          </Debounce>

          <el-upload style="display:inline-block;margin:0 10px" action="#" ref="uploadFail"
            :disabled="quoform.cvencheck=='已确认'" :show-file-list="false" :before-upload="brforeUploadreImportFail"
            :auto-upload="false" :on-change="handleChangeFail" :file-list="fileListFail" :accept="typeaccept">
            <el-button type="success" size="medium" plain
              :disabled="quoform.cvencheck=='已确认'">上传合同（{{typeaccept}}）</el-button>
          </el-upload>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="warning" plain @click.native="GetHTFileUrl()" size="medium">预览</el-button>
          </Debounce>
          <el-button type="info" plain size="medium" @click.native="returnpage('1')">返回主表</el-button>
          <el-button type="info" plain size="medium" @click.native="returnpage('2')">返回首页</el-button>
        </div>
      </div>
      <!--  -->
      <div style="width:100%">
        <el-form :inline="true" :model="quoform" class="demo-form-inline itemwidth infodata" label-width="100px">
          <el-form-item label="合同号">
            <el-input v-model="quoform.chtcode" placeholder="合同号" disabled></el-input>
          </el-form-item>
          <!-- <el-form-item label="供应商名称">
            <el-input v-model="quoform.ccustomername" placeholder="供应商名称" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="生效日期">
            <el-input v-model="quoform.dhtstarttime" placeholder="合同生效日期" disabled></el-input>
          </el-form-item>
          <el-form-item label="失效日期">
            <el-input v-model="quoform.dhtendtime" placeholder="合同失效日期" disabled></el-input>
          </el-form-item>
          <!-- <el-form-item label="合同类型">
            <el-input v-model="quoform.chttype" placeholder="合同类型" disabled></el-input>
          </el-form-item> -->

          <el-form-item label="物料类别">
            <el-input v-model="quoform.cinvtype" placeholder="物料类别" disabled></el-input>
          </el-form-item>
          <el-form-item label="要求确认时间">
            <el-input v-model="quoform.dloadendtime" placeholder="上传截止日期" disabled></el-input>
          </el-form-item>
          <el-form-item label="实际确认时间">
            <el-input v-model="quoform.dvencheckdate" placeholder="实际确认时间" disabled></el-input>
          </el-form-item>
          <!-- <el-form-item label="日期">
            <el-input v-model="quoform.ddate" placeholder="日期" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="备注" class="cremark">
            <el-input v-model="quoform.cremark" placeholder="备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix"><b><i class="el-icon-s-unfold"></i>订单详情</b></div>
      <el-table :data="tableData" max-height="420" style="width: 100%; background: transparent" border
        :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }"
        class="tb-edit" row-key="id" highlight-current-row>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="cpastureinfo" label="公司信息" width="180" />
        <!-- <el-table-column prop="csrmcinvcode" label="SRM物料号" /> -->
        <el-table-column prop="cinvdescribe" label="物料描述" />
        <el-table-column prop="cspecification" label="规格" width="100" />
        <!-- 暂无字段 -->
        <el-table-column prop="cunit" label="计量单位" width="100" />
        <!-- 判断合同类型如果是价格合同合同含税金额不要显示 -->
        <el-table-column prop="ihtnumber" label="合同数量" width="100" v-if="quoform.chttype!='价格合同'" />
        <el-table-column prop="irateprice" label="含税单价" width="100" />
        <el-table-column prop="ipriceunit" label="价格单位" width="100" />
        <el-table-column prop="irate" label="税率" width="100" />
        <el-table-column prop="itotalmoney" label="含税金额" width="100" v-if="quoform.chttype!='价格合同'" />
        <el-table-column prop="cfileurl" label="备注" />
        <!-- 结束 -->
      </el-table>
    </el-card>
  </div>
</template>

<script>
  import { RemovePruchaseToDo, GetFileType } from "../../../../api/home";
  export default {
    data() {
      return {
        quoform: {},
        tableData: [],
        suprow: {},
        urid: "",
        fileListFail: [],
        fileurl: "",
        typeaccept: "",
        previnformdata: {},
      };
    },
    created() {
      this.urid = window.localStorage.getItem("token");

      if (this.$route.params.rows) {
        this.suprow = this.$route.params.rows;
        sessionStorage.setItem("suprow", JSON.stringify(this.$route.params.rows));
        this.previnformdata = this.$route.params.informdata;
        sessionStorage.setItem(
          "informdata",
          JSON.stringify(this.$route.params.informdata)
        );
      } else {
        this.suprow = JSON.parse(sessionStorage.getItem("suprow"));
        this.previnformdata = JSON.parse(sessionStorage.getItem("informdata"));
      }
      console.log(this.suprow);
      this.GitHtsigningInfo();
      this.FileType();
    },
    methods: {
      // 获取文件类型
      FileType() {
        GetFileType({ type: "04" }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.typeaccept = res.data.Data[0].cfileformat;
          }
        });
      },
      // 获取信息
      GitHtsigningInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GitHtsigningInfo",
          data: { KeyValue: this.suprow.id },
        }).then((res) => {
          console.log(res, "获取信息结果");

          if (res.data.Success) {
            this.quoform = res.data.Data.dt[0];
            this.tableData = res.data.Data.dt2;

            // this.informdata = res.data.Data.dt3[0];
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      //  确认
      PriceSubmit() {
        this.$confirm("点击确认之后将无法在上传文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios({
              method: "post",
              url: "CommonModule/Op_Supplier/QueryHtsigning",
              data: { KeyValue: this.suprow.id, chtloadannex: this.fileurl },
            }).then((res) => {
              console.log(res, "确认");
              if (res.data.Success) {
                this.$message.success("确认成功！");
                this.removerp();
                this.returnpage("1");
              } else {
                this.$message.error(res.data.Message);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      },
      // 删除待办事项中的信息
      removerp() {
        RemovePruchaseToDo({
          KeyValue: this.suprow.id,
        }).then((res) => {
          console.log(res);
        });
      },
      // 下载

      async down() {
        await this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/DownLoadFile", // 请求地址
          data: { type: "ContractTemplate", KeyValue: this.suprow.id }, // 参数
        }).then(
          (res) => {
            console.log(res);
            if (res.data.Data != "") {
              // 根据浏览地址下载文件;
              const a = document.createElement("a");
              let urlblob = this.global.bxiosdow + res.data.Data.path;
              window.open(urlblob);

              // fetch(urlblob)
              //   .then((res) => res.blob())
              //   .then((blob) => {
              //     // 将链接地址字符内容转变成blob地址
              //     a.href = URL.createObjectURL(blob);
              //     console.log(a.href);
              //     a.download = ""; // 下载文件的名字
              //     document.body.appendChild(a);
              //     a.click();
              //   });
              // alert(res.data.Data);
              // window.open(res.data.Data);
            } else {
              this.$message.error("暂无文件");
            }
          },
          (err) => {
            console.log(err);
          }
        );

        // this.$axios({
        //   method: "post",
        //   url: "CommonModule/Op_Supplier/GetHTFileUrl", // 请求地址
        //   data: { ctype: "02", KeyValue: this.suprow.id }, // 参数
        //   responseType: "blob", // 表明返回服务器返回的数据类型
        // }).then(
        //   (response) => {
        //     console.log(response);
        //     // let blob = new Blob([response.data], {
        //     //   type: "application/octet-stream",
        //     // });
        //     let blob = new Blob([response.data], {
        //       type: "application/octet-stream",
        //     }); // type要设置格式
        //     // 获取文件名
        //     let fileName = response.headers["content-diposition"]
        //       .split(";")[1]
        //       .split("=")[1];
        //     // console.log(response.headers["content-disposition"]);
        //     console.log(fileName);
        //     let link = document.createElement("a");
        //     link.style.display = "none";
        //     link.href = URL.createObjectURL(blob); // 下载地址
        //     link.setAttribute("download", decodeURI(fileName));
        //     document.body.appendChild(link);
        //     link.click();
        //     URL.revokeObjectURL(link.href); // 释放URL 对象
        //     document.body.removeChild(link);
        //   },
        //   (err) => {
        //     reject(err);
        //   }
        // );
      },

      // 预览
      GetHTFileUrl() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetHTFileUrl",
          data: { KeyValue: this.suprow.id, ctype: "01" },
        }).then((res) => {
          console.log(res, "预览");
          if (res.data.Success) {
            if (res.data.Data != "") {
              window.open(this.global.BASE_URL + res.data.Data);
            } else {
              this.$message.error("暂无文件");
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 返回
      returnpage(type) {
        sessionStorage.removeItem("params");
        if (type == "1") {
          this.$router.push({
            path: "/OnlineContractList/OnlineContractList",
            query: { informdata: this.previnformdata },
          });
        } else {
          this.$router.push({ path: "/home" });
        }
      },

      //上传文件
      handleChangeFail(file, fileList) {
        this.$refs.uploadFail.submit();
      },
      // 上传文件
      brforeUploadreImportFail(file) {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SupplierCheckAll",
          data: { cbilltype: "在线合同上传", cbillid: this.suprow.id },
        }).then((res) => {
          // console.log(res, "上传结果果上传结果");
          if (res.data.Success) {
            let varparams = new FormData();
            varparams.append("file", file);
            varparams.append("file", URL.createObjectURL(file));
            varparams.append("cvoucherno", "op_htsigning");
            varparams.append("ctype", "04");
            varparams.append("cvoucherid", this.suprow.id);
            this.$axios({
              method: "post",
              url: "CommonModule/Op_Supplier/BaseUploadFile",
              headers: { "Content-Type": "multipart/form-data" },
              data: varparams,
              timeout: 30000000,
            }).then((res) => {
              console.log(res, "上传结果");

              if (res.data.Success) {
                this.$message({
                  howClose: true,
                  message: "上传成功",
                  type: "success",
                });
                this.fileurl = res.data.Data.Path;
              } else {
                this.$message.error(res.data.Message);
              }
            });

            return false; //屏蔽了action的默认上传
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
    },
  };
</script>
<style scoped>
  .itemwidth .el-input {
    width: 160px;
  }

  .itemwidth .el-select {
    width: 160px;
  }

  .cremark .el-input {
    width: 430px;
  }
</style>